// src/pages/AdminUploadPage.js

import React, { useState, useEffect } from "react";
import { getDatabase, ref, set, get } from "firebase/database";
import { getAuth, onAuthStateChanged, signOut } from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { initializeApp } from "firebase/app";
import AppTopBar from "../components/AppTopBar";
import AppFooter from "../components/AppFooter";

// Firebase config
const firebaseConfig = {
  apiKey: "AIzaSyAaR9ZU1w_bFxMKMbNxu-9eBpuOOGm1Eow",
  authDomain: "bookingappv1-d1e2d.firebaseapp.com",
  databaseURL: "https://bookingappv1-d1e2d-default-rtdb.firebaseio.com/",
  projectId: "bookingappv1-d1e2d",
  storageBucket: "bookingappv1-d1e2d.appspot.com",
  messagingSenderId: "134532713601",
  appId: "1:134532713601:web:5ad89fec3f4bf09b519180",
};

const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
const auth = getAuth(app);

const allowedFiles = [
  "class_schedulesA.csv",
  "class_schedulesB.csv",
  "room_access.csv",
  "rooms.json",
  "unavailable_schedules.csv",
  "adminLevels.csv",
];

export default function AdminUploadPage() {
  const [status, setStatus] = useState("");
  const [user, setUser] = useState(null);
  const [selectedFile, setSelectedFile] = useState(null);
  const navigate = useNavigate();
  const [showMenu, setShowMenu] = useState(false);
  const [fileUploadInfo, setFileUploadInfo] = useState({});

  useEffect(() => {
    onAuthStateChanged(auth, (currentUser) => {
      if (
        !currentUser ||
          (!currentUser.email.endsWith("@uevora.pt") &&
            !currentUser.email.endsWith("@alunos.uevora.pt"))
      ) {
        navigate("/");
      } else {
        setUser(currentUser);
        fetchUploadInfo();
      }
    });
  }, [navigate]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest('.menu-dropdown')) {
        setShowMenu(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const fetchUploadInfo = async () => {
    const uploadRef = ref(db, "uploads");
    try {
      const snapshot = await get(uploadRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        setFileUploadInfo(data);
      }
    } catch (error) {
      console.error("Error fetching upload info:", error);
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    if (!allowedFiles.includes(file.name)) {
      setStatus("❌ Invalid file name. Only specific files can be uploaded.");
      return;
    }

    setSelectedFile(file);
    setStatus(`Ready to upload: ${file.name}`);
  };

  const handleConfirmUpload = async () => {
    if (!selectedFile || !user) return;

    const reader = new FileReader();
    reader.onload = async (event) => {
      const fileContent = event.target.result;
      const fileName = selectedFile.name.replace(/\.[^/.]+$/, "");

      try {
        await set(ref(db, `uploads/${fileName}`), {
          content: fileContent,
          uploadedBy: user.email,
          timestamp: new Date().toISOString(),
        });
        setStatus(`✅ ${selectedFile.name} uploaded to the database.`);
        setSelectedFile(null);
        fetchUploadInfo();
      } catch (error) {
        console.error("Upload error:", error);
        setStatus("❌ Upload failed.");
      }
    };

    reader.readAsText(selectedFile);
  };

  const handleSignOut = () => {
    signOut(auth).then(() => navigate("/"));
  };
  const goToBuildings = () => {
    navigate("/buildings");
  };
  const goToMyReservations = () => {
    navigate("/my-reservations");
  };
  const goToAdminReservations = () => {
    navigate("/admin-reservations");
  };

  return (
    <div className="flex flex-col p-6 pt-28 items-center justify-start min-h-screen bg-gray-800 text-gray-100 p-8">
      <AppTopBar />
      <h1 className="w-full mb-8 text-left px-6 text-xl font-bold">
        Admin Upload Panel
      </h1>

      <p className="w-full text-gray-300 mb-4">
        Upload one of the following files:
      </p>
      <ul className="w-full px-6 mb-4 text-sm text-green-300 space-y-1">
        {allowedFiles.map((f) => {
          const fileKey = f.replace(/\.[^/.]+$/, ""); // Strip extension
          const info = fileUploadInfo[fileKey];
          return (
            <li key={f}>
              • {f}
              {info ? (
                <span className="text-gray-400 ml-2">
                  (uploaded by <span className="text-white">{info.uploadedBy}</span> on{" "}
                  <span className="text-white">
                    {new Date(info.timestamp).toLocaleString("en-GB", {
                      day: "2-digit",
                      month: "2-digit",
                      year: "numeric",
                      hour: "2-digit",
                      minute: "2-digit",
                    })}
                  </span>
                  )
                </span>
              ) : (
                  <span className="text-red-400 ml-2">(not uploaded yet)</span>
                )}
            </li>
          );
        })}
      </ul>

      {/* Show this only if no file is selected */}
      {!selectedFile && (
        <div className="w-full flex justify-center mt-4">
          <label className="cursor-pointer bg-purple-600 hover:bg-purple-700 text-white px-4 py-2 rounded">
            Upload a file
            <input
              type="file"
              onChange={handleFileChange}
              className="hidden"
            />
          </label>
        </div>
      )}

      {/* Show this only if a file is selected */}
      {selectedFile && (
        <div className="w-full flex justify-center mt-4">
          <button
            onClick={handleConfirmUpload}
            className="bg-orange-600 hover:bg-orange-700 text-white px-6 py-2 rounded"
          >
            Confirm Upload
          </button>
        </div>
      )}

      <p className="text-center mt-2 text-sm text-gray-300">{status}</p>
      <AppFooter />
    </div>
  );
}
